import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { useAppSelector, useAppDispatch } from "hooks/store";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { setdeliveryType } from "store/slices/main.slice";
import { ORDER } from "utils/constants";

interface OrderTypePopupProps {

  setStage: (v: string) => void;
}

const OrderType: React.FC<OrderTypePopupProps> = ({
  setStage,
}) => {
  const [orderType, setOrderType] = useState<"pickup" | "delivery">("pickup");
  const dispatch = useAppDispatch();

  const handleSubmit = () => {
    if(orderType !== "pickup") { 
        dispatch(setdeliveryType(orderType));
    }else{
        dispatch(setdeliveryType(orderType));
    }
    setStage("CART"); 
  };

  return (
<div className="flex items-center justify-center p-4 sm:p-6 lg:p-8">
<div className="bg-white p-6  max-w-md w-full">
        <div className="flex flex-col items-center text-center mb-6">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
            Choose Your Order Type
          </h2>
          <p className="text-sm sm:text-base text-gray-500 mt-2">
            Select whether you'd like to pick up your order or have it delivered.
          </p>
        </div>

        {/* Order Type Buttons */}
        <div className="flex flex-col gap-4 rounded-xl p-1 mt-6 mb-8">
          <button
            className={`${
              orderType === "pickup"
                ? "bg-primary text-themeSelColor shadow-lg"
                : "bg-gray-200 text-gray-700"
            } py-2 px-4 rounded-lg flex-1 transition-transform duration-300 hover:scale-105`}
            onClick={() => setOrderType("pickup")}
          >
            Pickup
          </button>
          <button
            className={`${
              orderType === "delivery"
                ? "bg-primary text-themeSelColor shadow-lg"
                : "bg-gray-200 text-gray-700"
            } py-2 px-4 rounded-lg flex-1 transition-transform duration-300 hover:scale-105`}
            onClick={() => setOrderType("delivery")}
          >
            Delivery
          </button>
        </div>

        {/* Continue Button */}
        <Button
          onClick={handleSubmit}
          disabled={!orderType}
          variant="contained"
          className="!w-full !bg-primary !text-themeSelColor !py-3 !rounded-lg !text-lg "
        >
          Continue
        </Button>
 </div>
 </div>
  );
};

export default OrderType;
